import axios from 'axios'
import qs from  'qs'
// import {LOCAL} from "../env/index_prod";
import {LOCAL} from "../env/index";

let captcha = "/gecp/common/login/captcha";
let sep_cloudDisk = "/sep/#/cloudDisk";
let cae_index = "/cae/#/";
if(LOCAL){
  captcha = "/api"+captcha;
  sep_cloudDisk = "http://localhost:8081/#/cloudDisk";
  cae_index = "http://localhost:8082";
}
export {captcha, sep_cloudDisk, cae_index};

if(LOCAL) {
// 接口地址修改
  axios.defaults.baseURL = '/api'
}

// 登录接口
export let username =(data)=>(axios.post('/gecp/common/login/login/username',qs.stringify(data)))

// 忘记密码的短信验证码
export let smsCode =(data)=>(axios.post('/gecp/common/login/smsCode',qs.stringify(data)))

// 忘记密码重置
export let reset =(data)=>(axios.post('/gecp/common/login/login/reset',qs.stringify(data)))



export let checkUsername =(data)=>(axios.get('/gecp/common/register/check/username',{params:data}))

export let register =(data)=>(axios.post('/gecp/common/register/register/username',qs.stringify(data)))



export let logout =(data)=>(axios.post('/gecp/common/login/logout',qs.stringify(data)))


// 获取用户登录态
export let userState =()=>(axios.get('/gecp/common/userCenter/search'))


export let latestPackage =(data)=>(axios.get('/cms/latestPackage',{params:data}))


export let getCmsList = (data)=>(axios.get('/cms/searchFiles',{params:data}));


// 下载锚点
export let downloadCount =(data)=>(axios.post('/cms/downloadPackage',qs.stringify(data)))

export let trial = (data)=>(axios.post('/gecp/common/userCenter/trial',qs.stringify(data)))


export let listCategory = (data)=>(axios.get('/cms/listCategory',{params:data}));
export let searchFiles = (data)=>(axios.get('/cms/searchFiles',{params:data}));
export let listRelationFiles = (data)=>(axios.get('/cms/listRelationFiles',{params:data}));


export let listFileRelationStatus = (data)=>(axios.get('/cicd/api/cms/listFileRelationStatus',{params:data}));

//获取用户信息
export let tempToken = (data)=>(axios.post('/gecp/common/login/login/tempToken',qs.stringify(data)))
//获取最新视频
export let searchFilesPage = (data)=>(axios.get('/cms/searchFilesPage?',{params:data}));
//获取视频地址
export let getFile = (data)=>(axios.get('cms/getFile',{params:data}));



// WEBPACK FOOTER //
// ./src/api/index.js